export const COLUMN_BASIS = 260;
